import { HEDGE_TYPES, HEDGE_STATUSES } from "@loanbossinc/component-library";
import { isContainedInList } from "helpers/row-logic-helper";

export const shouldShowMarketRate = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [,
    HEDGE_STATUSES.WATCH]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [,
    HEDGE_TYPES.SWAP]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowTerm = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [,
    HEDGE_STATUSES.WATCH]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [,
    HEDGE_TYPES.SWAP]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowMarketCost = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.WATCH
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.CAP
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowMarkToMarket = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.ACTIVE
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.CAP,
    HEDGE_TYPES.SWAP
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowNotional = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.WATCH
]);

export const shouldShowRate = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.ACTIVE,
    HEDGE_STATUSES.TERMINATED
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.SWAP
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowStrike = hedge => isContainedInList(hedge, "hedgeTypeId", [
  HEDGE_TYPES.CAP,
  HEDGE_TYPES.FLOOR
]);

export const shouldShowUpperStrike = hedge => isContainedInList(hedge, "hedgeTypeId", [
  HEDGE_TYPES.CORRIDOR
]);

export const shouldShowLowerStrike = hedge => isContainedInList(hedge, "hedgeTypeId", [
  HEDGE_TYPES.CORRIDOR
]);

export const shouldShowCap = hedge => isContainedInList(hedge, "hedgeTypeId", [
  HEDGE_TYPES.COLLAR
]);

export const shouldShowFloor = hedge => isContainedInList(hedge, "hedgeTypeId", [
  HEDGE_TYPES.COLLAR
]);

export const shouldShowTerminationValue = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowNotionalAtTermination = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowTradeDate = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowEffectiveDate = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowTerminationDate = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowEarlyTerminationDate = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowMaturityType = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.WATCH
]);

export const shouldShowPremium = hedge => {
  const isHedgeStatus = isContainedInList(hedge, "hedgeStatusId", [
    HEDGE_STATUSES.ACTIVE,
    HEDGE_STATUSES.TERMINATED
  ]);

  const isHedgeType = isContainedInList(hedge, "hedgeTypeId", [
    HEDGE_TYPES.CAP,
    HEDGE_TYPES.COLLAR,
    HEDGE_TYPES.CORRIDOR,
    HEDGE_TYPES.FLOOR
  ]);

  return isHedgeStatus && isHedgeType;
};

export const shouldShowHedgeProvider = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);

export const shouldShowSpread = hedge => isContainedInList(hedge, "hedgeTypeId", [
  HEDGE_TYPES.SWAP
]);

export const shouldShowCreditCharge = hedge => isContainedInList(hedge, "hedgeTypeId", [
  HEDGE_TYPES.SWAP
]);

export const shouldShowHedgeTypeMonitored = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.WATCH
]);
export const shouldShowHedgeTypeActiveTerm = hedge => isContainedInList(hedge, "hedgeStatusId", [
  HEDGE_STATUSES.ACTIVE,
  HEDGE_STATUSES.TERMINATED
]);
